<template>
	<Accessible
		name="usersearch"
		autoFocus
		focusFirstItem
		trapped
		:tabOrder="tabOrder"
		:class="{ 'user-search-wrapper-modal': config.inModal }"
		ref="accessible"
	>
		<div :class="{ userSearchModal: config.inModal }" ref="userSearchModal">
			<div v-if="config.title" class="upload-title">{{ config.title }}</div>

			<div id="userSearchBox" ref="userSearchBox">
				<div
					v-for="(select, index) in selected"
					:key="index"
					class="user-select-pill pointer"
					@click="selectUser(select)"
				>
					<div
						class="user-select-pill-profile-wrapper"
						v-bind:class="{ 'user-select-pill-middle': !isFirefox }"
					>
						<ProfilePic
							:user="select"
							size="24px"
							class="user-select-pill-profile"
						/>
					</div>
					<div class="user-select-pill-name">
						<div
							class="unfurl-providername"
							style="
								font-size: 15px;
								color: rgb(255, 255, 255);
								margin-bottom: 0px;
							"
						>
							{{ store.getUserName(select) }}
						</div>
					</div>
					<div class="user-select-pill-close">
						<input
							type="image"
							src="/images/common/white-close.png"
							style="width: 10px"
						/>
					</div>
				</div>

				<input
					id="userFilter"
					ref="userFilter"
					type="text"
					:placeholder="placeHolderText"
					class="standard-box"
					style="width: 100%; outline: 0"
					v-model="searchText"
				/>
			</div>

			<div v-if="config.filtering" class="user-search-filter">
				<div class="filter-span-text">
					{{ this.$t('contacts_userpicker_filter_title') }}
				</div>
				<div class="user-search-filter-dropdown">
					<div
						class="filter"
						v-on-click-outside="closeFilter"
						:style="{ top: filterTop() }"
					>
						<button
							v-if="showButton"
							@click.stop="showMain = !showMain"
							class="filter-button"
						>
							{{ filterName }}
						</button>
						<div
							v-if="showButton"
							@click.stop="showMain = !showMain"
							class="filter-button-arrow pointer"
							v-bind:style="{ top: filterButtonHeight() }"
						>
							<img src="/images/common/icon-dropdown.png" />
						</div>
						<div v-show="showMain" class="main-menu">
							<div
								class="main-item organization-item"
								:class="{
									'selected-filter': selectedFilter == 'organization',
									'disabled-div': !store.checkOrgPermission('search_org'),
								}"
								@click.stop="filterOrganization"
							>
								<div
									@click.stop="showMain = !showMain"
									class="filter-button-arrow"
									style="top: 1px; right: 1px; padding-top: 9px"
								>
									<img src="/images/common/icon-dropdown.png" />
								</div>
								<div>{{ $t('contacts_filterpicker_organization_title') }}</div>
								<span v-if="store.checkOrgPermission('search_org')">{{
									$t('contacts_filterpicker_organization_description')
								}}</span>
								<span v-if="!store.checkOrgPermission('search_org')">{{
									$t('contacts_filterpicker_description_disabled')
								}}</span>
							</div>
							<div
								class="main-item connections-item"
								:class="{ 'selected-filter': selectedFilter == 'connections' }"
								@click.stop="filterConnections"
							>
								<div>{{ $t('contacts_filterpicker_connections_title') }}</div>
								<span>{{
									$t('contacts_filterpicker_connections_description')
								}}</span>
							</div>
							<div
								class="main-item group-item"
								:class="{ 'selected-filter': selectedFilter == 'group' }"
								@click.stop="showSub = true"
								@mouseover="showSub = true"
							>
								<div>
									{{
										groupTitle
											? $t('contacts_filterpicker_group_title_selected', [
													groupTitle,
											  ])
											: $t('contacts_userbubblepicker_option_bubbles_single')
									}}
								</div>
								<span
									>{{ $t('contacts_filterpicker_group_description') }}.</span
								>
								<div style="position: absolute; bottom: 20px; right: 15px">
									<img src="/images/common/settings-forward-arrow.png" />
								</div>
							</div>
						</div>

						<div
							v-show="showSub"
							class="sub-menu"
							v-bind:style="{ maxHeight: subMenuHeight() }"
						>
							<div
								class="sub-item"
								v-for="category in categories"
								:key="category.id"
							>
								<div class="category-name" :title="category.name">
									{{ category.name }}
								</div>
								<div
									class="group"
									v-for="group in category.groups"
									:key="group.id"
									:title="group.title"
									@click="filterGroup(group)"
									:class="{ 'group-item-is-selected': groupIsSelected(group) }"
								>
									{{ group.title }}
									<img
										v-if="groupIsSelected(group)"
										src="/images/pronto/pronto-check.png"
										style="position: absolute; right: 0; top: 19px"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="search-for-anyone-in"></div>
			</div>

			<div v-show="!showLoading && !noResults">
				<ul
					id="userSearch"
					class="user-search-list user-search-list-group"
					ref="userSearchList"
					v-bind:class="{
						'user-search-list-filtering': config.filtering && !config.inModal,
						'user-search-list-multi': config.multiple,
						'user-search-list-opacity': showMain,
						'user-search-list-multi-modal': config.inModal,
					}"
				>
					<slot name="first-list-items" />
					<li
						v-for="user in userList"
						@click="selectUser(user)"
						:data-value="user.id"
						:key="user.id"
						class="user-search-item"
						:aria-label="user.fullname"
					>
						<div class="user-search-content-container">
							<ProfilePic
								:user="user"
								size="46px"
								class="user-profile-img-container"
							/>
							<div class="user-name">
								<span class="ui-main">{{ user.fullname }}</span>
							</div>
						</div>
						<img
							v-if="isSelected(user)"
							class="user-search-selected-check"
							src="/images/pronto/pronto-check.png"
						/>
					</li>
					<div class="center">
						<div v-if="showPaging" id="mainSpinner" class="ios-spinner">
							<div class="bar1"></div>
							<div class="bar2"></div>
							<div class="bar3"></div>
							<div class="bar4"></div>
							<div class="bar5"></div>
							<div class="bar6"></div>
							<div class="bar7"></div>
							<div class="bar8"></div>
							<div class="bar9"></div>
							<div class="bar10"></div>
							<div class="bar11"></div>
							<div class="bar12"></div>
						</div>
					</div>
				</ul>
			</div>

			<div
				v-if="!showLoading && !noResults && config.multiple"
				class="upload-btn-wrapper"
				v-bind:class="{
					'upload-btn-wrapper-no-margin': config.multiple,
					'user-search-list-opacity': showMain,
				}"
			>
				<button class="btn-cancel-med mar-r-8" @click="close">Cancel</button>
				<button
					class="btn-submit-med mar-l-8"
					:disabled="disabled"
					@click="returnSelected"
				>
					Add
				</button>
			</div>

			<div
				v-if="showLoading"
				class="user-search-loading"
				:style="{ paddingTop: config.loaderpadding }"
			>
				<div style="font-family: Avenir-Medium; color: #8a8d93">
					{{ loadingText }}
				</div>
				<div v-if="showLoadingSpinner" id="mainSpinner" class="ios-spinner">
					<div class="bar1"></div>
					<div class="bar2"></div>
					<div class="bar3"></div>
					<div class="bar4"></div>
					<div class="bar5"></div>
					<div class="bar6"></div>
					<div class="bar7"></div>
					<div class="bar8"></div>
					<div class="bar9"></div>
					<div class="bar10"></div>
					<div class="bar11"></div>
					<div class="bar12"></div>
				</div>
			</div>

			<div
				v-if="noResults"
				style="text-align: center; padding-top: 25vh; padding-bottom: 25vh"
			>
				<div
					style="
						font-family: Avenir-Medium;
						color: #b7b9bd;
						font-size: 18px;
						margin-bottom: 10px;
					"
				>
					{{ resultsText }}
				</div>
				<div
					v-if="selectedFilter != 'organization'"
					class="no-results-small"
					style="font-family: Avenir-Medium; color: #b7b9bd"
				>
					Having trouble finding someone?
				</div>
				<div v-if="selectedFilter != 'organization'" class="no-results-small">
					<a
						class="adjust-search-filter-link"
						href="#"
						@click.prevent.stop="showMain = !showMain"
						>Try adjusting the search filter</a
					>
				</div>
			</div>
		</div>
	</Accessible>
</template>

<script>
import store, {
	getChatsForCategory,
	getChatsWithNoCategory,
	getCategories,
} from '@/store'
import { isFirefox, isSafari } from '@/store'
import debounce from 'debounce'
import * as rest from '@/api/rest'
import Accessible from '@/components/common/Accessible'
import ProfilePic from './common/ProfilePic.vue'

const PAGE_SIZE = 30

export default {
	name: 'UserSearch',
	components: { Accessible, ProfilePic },
	props: ['config'],
	data() {
		return {
			store,
			isFirefox,
			userList: [],
			selected: [],
			disabled: true,
			currentPage: 1,
			hasMore: false,
			searchText: '',
			showLoading: false,
			showPaging: false,
			requestID: null,
			placeHolderText: this.$t('contacts_userpicker_search_placeholder'),
			noResults: false,
			filterName: store.checkOrgPermission('search_org')
				? this.$t('contacts_filterpicker_organization_title')
				: this.$t('contacts_filterpicker_connections_title'),
			showButton: true,
			showMain: false,
			showSub: false,
			selectedFilter: store.checkOrgPermission('search_org')
				? 'organization'
				: 'connections',
			categories: [],
			selectedFilterBubble: '',
			delay: 100,
			loadingText: this.$t('common_loader_loading_title'),
			resultsText: this.$t('common_loader_noresults_title'),
			showLoadingSpinner: true,
			apiResponse: null,
		}
	},

	emits: ['close', 'selectedUsers'],

	created() {
		this.searchForUserDebounced = debounce(this.searchForUser.bind(this), 500)

		this.$onEventBus('showUserSuccessState', (data) => {
			this.showLoading = true
			this.showLoadingSpinner = false
			this.loadingText = this.$t('common_success')
		})
	},

	mounted() {
		if (this.config.filtering) {
			getCategories().forEach((category) => {
				let catObj = {
					name: category.title.toUpperCase(),
				}

				let group_list = []
				getChatsForCategory(category.id).forEach(function (bubble) {
					group_list.push({ id: bubble.id, title: bubble.title })
				})

				catObj.groups = group_list
				this.categories.push(catObj)
			})

			//other groups
			let group_list = []
			let other_groups = {
				name: this.$t(
					'chat_drawer_section_bubbles_uncatagorized'
				).toUpperCase(),
			}
			getChatsWithNoCategory().forEach(function (bubble) {
				group_list.push({ id: bubble.id, title: bubble.title })
			})

			other_groups.groups = group_list
			this.categories.push(other_groups)
		} else {
			this.selectedFilter = ''
		}

		if (this.config.orgList) {
			this.selectedFilter = 'organization'
		}

		this.showLoading = true
		this.searchForUser()

		this.$nextTick(() => {
			this.$refs.userSearchList?.addEventListener('scroll', this.onScroll)
		})

		this.$refs.userFilter.focus()
	},

	beforeUnmount() {
		this.$refs.userSearchList?.removeEventListener('scroll', this.onScroll)
	},

	watch: {
		searchText: function (val, oldVal) {
			this.currentPage = 1
			this.hasMore = false
			this.showLoading = true
			this.noResults = false
			this.userList = []
			this.searchForUserDebounced()
		},

		filterName: function (val, oldVal) {
			if (this.config.filtering) {
				this.currentPage = 1
				this.hasMore = false
				this.showLoading = true
				this.noResults = false
				this.userList = []
				this.searchForUserDebounced()
			}
		},

		showMain: function (val) {
			if (val == false) {
				this.showSub = false
				this.showButton = true
			} else {
				this.showButton = false
			}
		},

		selected: {
			handler() {
				if (this.selected.length > 0) {
					this.placeHolderText = ''
					this.disabled = false
					if (!this.config.multiple) {
						this.returnSelected()
					}
				} else {
					this.placeHolderText = this.$t(
						'contacts_userpicker_search_placeholder'
					)
					this.disabled = true
				}

				this.$nextTick(() => {
					//adjust height of the user list;
					let overall_height = this.$refs.userSearchModal.clientHeight
					let search_height = this.$refs.userSearchBox.clientHeight
					if (search_height < 63) {
						search_height = 63
					}

					if (this.config.filtering) {
						search_height = search_height + 250
					} else {
						search_height = search_height + 192
					}
					const div_height = this.config.inModal ? '80vh - ' : '90vh - '
					this.$refs.userSearchList.style.height =
						'calc(' + div_height + search_height + 'px)'

					//scroll to the bottom of the searchbox always
					let scroll_height = this.$refs.userSearchBox.scrollHeight
					const searchBox = document.getElementById('userSearchBox')
					if (searchBox) {
						searchBox.scrollTop = scroll_height
					}
				})
			},
			deep: true,
		},

		userList(userList, prev) {
			if (userList.length !== prev?.length) {
				this.$nextTick(() => this.$refs.accessible.focusMe())
			}
		},
	},

	computed: {
		groupTitle() {
			if (this.selectedFilter === 'group' && this.filterName) {
				return this.filterName
			} else {
				return ''
			}
		},
		tabOrder() {
			// this count just forces the 'all' list to requery whenever the user list changes
			const count = this.userList?.length || 0
			return [
				{ css: '#userSearchBox input', clickOnEnter: true },
				{
					all: '.user-search-list .user-search-item',
					clickOnEnter: true,
					count,
					Enter: async (a, b, c, accessible) => {
						await accessible.sleep(100)
						accessible.moveToAccessibleByName('taskdetails')
					},
				},
			]
		},
	},

	methods: {
		isSelected(user) {
			//return this.selected.includes(user.id);
			let userObj = this.selected.find((x) => x.id === user.id)
			if (userObj) {
				return true
			} else {
				return false
			}
		},

		onScroll() {
			if (this.timeout) window.clearTimeout(this.timeout)

			const { userSearchList } = this.$refs
			this.timeout = window.setTimeout(() => {
				const atBottom = !(
					userSearchList.scrollTop + userSearchList.clientHeight + 1 <
					userSearchList.scrollHeight - 50
				)

				if (atBottom && this.hasMore) {
					this.showPaging = true
					this.searchForUserDebounced()
				}
			}, 100)
		},

		close() {
			this.$emit('close')
		},

		async searchForUser() {
			let current_id = this.uniqueID()
			this.requestID = current_id

			var post_data = { 'page[size]': PAGE_SIZE }
			if (this.selectedFilter === 'connections') {
				post_data['filter[relation]'] = 'connections'
			} else if (this.selectedFilter === 'group') {
				post_data['filter[bubble_ids][]'] = this.selectedFilterBubble
			} else {
				post_data['filter[relation]'] = 'all'
			}

			if (this.searchText) {
				post_data['filter[query]'] = this.searchText
			}

			if (this.currentPage === 1) {
				this.apiResponse = await rest.get('users/search', post_data)
			} else if (this.apiResponse?.next) {
				this.apiResponse = await this.apiResponse.next()
			} else {
				return
			}

			const { data, links } = this.apiResponse
			if (data.length > 0 && current_id === this.requestID) {
				const filteredUsers = data
				if (this.currentPage == 1) {
					this.userList = filteredUsers
					if (this.$refs.userSearchList) {
						this.$refs.userSearchList.scrollTop = 0
					}
					this.$nextTick(() => {
						if (this.$refs.userSearchList) {
							this.$refs.userSearchList.scrollTop = 0
						}
					})
				} else {
					this.userList = this.userList.concat(filteredUsers)
				}

				this.showLoading = false
				this.showPaging = false

				this.currentPage = this.currentPage + 1
				if (links.next) {
					this.hasMore = true
				} else {
					this.hasMore = false
				}
			} else if (data.length === 0 && current_id === this.requestID) {
				this.showPaging = false
				this.showLoading = false
				if (this.userList.length === 0) {
					this.noResults = true
				}
			}
		},

		uniqueID() {
			return '_' + Math.random().toString(36).substr(2, 9)
		},

		selectUser(user) {
			let userObj = this.selected.find((x) => x.id === user.id)
			if (userObj) {
				this.selected = this.selected.filter((x) => x.id !== user.id)
			} else {
				this.selected.push(user)
			}

			this.searchText = ''
			this.$refs.userFilter.focus()
		},

		userProfile(user) {
			return 'url(' + this.store.userProfile(user) + ')'
		},

		returnSelected() {
			if (this.selected.length > 0) {
				this.$emit('selectedUsers', this.selected)
			}

			this.$nextTick(() => {
				if (
					this.config.showAddingFlag &&
					this.loadingText === this.$t('common_loader_loading_title')
				) {
					this.loadingText = this.$t('contacts_userpicker_adding_users')
					this.showLoading = true
				}
			})
		},

		closeFilter() {
			this.showMain = false
			this.showSub = false
		},

		updateFilterName(name) {
			this.filterName = name
			this.showMain = false
		},

		filterConnections() {
			this.updateFilterName(this.$t('contacts_filterpicker_connections_title'))
			this.selectedFilter = 'connections'
		},

		filterOrganization() {
			this.updateFilterName(this.$t('contacts_filterpicker_organization_title'))
			this.selectedFilter = 'organization'
		},

		filterGroup(group) {
			this.updateFilterName(group.title)
			this.selectedFilterBubble = group.id
			this.selectedFilter = 'group'
		},

		maxHeight() {
			if (this.config.maxheight) {
				if (this.config.filtering) {
					return 'calc(' + this.config.maxheight + ' - 120px'
				} else {
					return 'calc(' + this.config.maxheight + ' - 50px'
				}
			} else {
				return 'calc(75vh - 50px)'
			}
		},

		subMenuHeight() {
			if (this.config.subMenuHeight) {
				return this.config.subMenuHeight
			} else {
				return '50vh'
			}
		},

		filterButtonHeight() {
			if (isSafari) {
				return '2px'
			} else {
				return 0
			}
		},

		filterTop() {
			if (isSafari) {
				return '4px'
			} else {
				return '6px'
			}
		},

		groupIsSelected(group) {
			if (
				group.id === this.selectedFilterBubble &&
				this.selectedFilter === 'group'
			) {
				return true
			} else {
				return false
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

$profile-size: 46px;
.user-select-pill {
	background-color: var(--teal-300);
	height: 36px;
	border: var(--teal-300);
	margin-top: 0.25rem;
	margin-right: 6px;
	line-height: 36px;
	display: table;
	padding-left: 5px;
	padding-right: 5px;
	border-radius: 10px;
}

.user-select-pill-profile,
.user-select-pill-name,
.user-select-pill-close {
	display: table-cell;
	vertical-align: middle;
}

.user-select-pill .user-select-pill-profile-wrapper,
.user-select-pill .user-select-pill-name,
.user-select-pill .user-select-pill-close {
	display: inline-block;
}

.user-select-pill-profile,
.user-select-pill-missing-profile {
	height: 24px;
	width: 24px;
	border-radius: 50%;
	margin-right: 2px;
}

.user-select-pill-close {
	margin-left: 20px;
	margin-right: 10px;
}

.user-search-wrapper-modal {
	width: 727px;
	border-radius: 15px;
	box-shadow: 0 8px 24px 0 #595959;
	text-align: left;
}

.user-select-pill-profile-wrapper {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: table-cell;
}

.user-select-pill-middle {
	vertical-align: middle;
	margin-right: 5px;
}

.userSearchModal {
	padding: 0 30px 0px 30px;
	height: 100%;
	overflow: scroll;
	width: 100%;
}

#userSearch li {
	width: 100%;
	border-bottom: 1px solid var(--neutral-40040);
}

#userSearchBox {
	padding: 0.5rem 0.5rem 0.75rem 16px;
	border: 1px solid var(--neutral-40040);
	border-radius: 0.25rem;
	cursor: text;
	display: flex;
	flex-wrap: wrap;
	font-size: 18px;
	line-height: 1.5rem;
	max-width: 100%;
	max-height: 150px;
	overflow-y: auto;
	min-height: 61px;
	overflow-x: hidden;
	background-color: var(--neutral-100);
}

#userFilter {
	margin-top: 0.25rem;
	margin-right: 6px;
	height: 36px;
	line-height: 36px;
	border: none;
	box-shadow: none;
	width: 150px;
	padding: 0;
	margin-bottom: 0;
	flex: 1;
	font-family: Avenir-Medium;
	font-size: 18px;
	outline: 0;
	background-color: var(--neutral-100);
	color: var(--neutral-800);
}

.member_token {
	position: relative;
	background: #2d9ee0;

	color: var(--neutral-800);
	border-radius: 0.2rem;
	font-weight: 700;
	font-size: 15px;
	padding-left: 32px;
	padding-right: 24px;
	cursor: pointer;
	flex: none;
	margin-top: 0.25rem;
	margin-right: 6px;
	height: 26px;
	line-height: 26px;
}

.member_image {
	position: absolute;
	left: 1px;
	top: 1px;
	border-bottom-right-radius: 0;
	border-top-right-radius: 0;
	width: 24px;
	height: 24px;
	border-radius: 0.2rem;
	border-top-right-radius: 0.2rem;
	border-bottom-right-radius: 0.2rem;
	background-size: 100%;
	background-repeat: no-repeat;
	display: inline-block;
}

.remove_member_token {
	position: absolute;
	right: 3px;
	top: 2px;
}

.ui-main {
	color: var(--neutral-800);
}

#userSearchBox:first-child {
	width: 100%;
}

.user-search-list {
	list-style: none;
	padding: 0;
	margin: 15px auto;
	overflow-y: auto;
	margin-left: -10px;
}

.user-search-list {
	li:hover {
		background: $light-blue;
	}
	.missing-img-white-bg {
		border: none;
	}
	#btnRemoveUser {
		display: block;
	}
}

.user-profile-img-border {
	border: 1px solid transparent;
}

.user-search-list button {
	margin-top: -22px;
	text-align: left;
	display: block;
	width: 100%;
	height: 100%;
	position: relative;
	cursor: pointer;
}

.user-search-list li:last-child {
	margin-bottom: 30px;
}

.user-search-list-div {
	margin-top: -12px;
	text-align: left;
	display: block;
	width: 100%;
	height: 100%;
	position: relative;
}

.user-search-list-img {
	line-height: $profile-size;
	position: absolute;
	text-align: center;
	margin-right: 15px;
	object-fit: cover;
}

.user-search-list-filtering {
	height: calc(90vh - 325px);
}

#mainSpinner {
	position: relative;
	width: 50px;
	height: 50px;
	display: inline-block;
	padding: 10px;
	border-radius: 10px;
	background: #ffffff;
	vertical-align: top;
	margin-top: 4.1px;
}

#smallSpinner {
	position: relative;
	width: 22px;
	height: 22px;
	display: inline-block;
	padding: 10px;
	border-radius: 10px;
	background: #ffffff;
	vertical-align: top;
	margin-top: 4.1px;
}

.ios-spinner div {
	width: 6%;
	height: 16%;
	background: #8a8d93;
	position: absolute;
	left: 49%;
	top: 43%;
	opacity: 0;
	-webkit-border-radius: 50px;
	-webkit-animation: fade 1s linear infinite;
}

@-webkit-keyframes fade {
	from {
		opacity: 1;
	}
	to {
		opacity: 0.25;
	}
}

.ios-spinner div.bar1 {
	-webkit-transform: rotate(0deg) translate(0, -130%);
	-webkit-animation-delay: 0s;
}

.ios-spinner div.bar2 {
	-webkit-transform: rotate(30deg) translate(0, -130%);
	-webkit-animation-delay: -0.9167s;
}

.ios-spinner div.bar3 {
	-webkit-transform: rotate(60deg) translate(0, -130%);
	-webkit-animation-delay: -0.833s;
}
.ios-spinner div.bar4 {
	-webkit-transform: rotate(90deg) translate(0, -130%);
	-webkit-animation-delay: -0.7497s;
}
.ios-spinner div.bar5 {
	-webkit-transform: rotate(120deg) translate(0, -130%);
	-webkit-animation-delay: -0.667s;
}
.ios-spinner div.bar6 {
	-webkit-transform: rotate(150deg) translate(0, -130%);
	-webkit-animation-delay: -0.5837s;
}
.ios-spinner div.bar7 {
	-webkit-transform: rotate(180deg) translate(0, -130%);
	-webkit-animation-delay: -0.5s;
}
.ios-spinner div.bar8 {
	-webkit-transform: rotate(210deg) translate(0, -130%);
	-webkit-animation-delay: -0.4167s;
}
.ios-spinner div.bar9 {
	-webkit-transform: rotate(240deg) translate(0, -130%);
	-webkit-animation-delay: -0.333s;
}
.ios-spinner div.bar10 {
	-webkit-transform: rotate(270deg) translate(0, -130%);
	-webkit-animation-delay: -0.2497s;
}
.ios-spinner div.bar11 {
	-webkit-transform: rotate(300deg) translate(0, -130%);
	-webkit-animation-delay: -0.167s;
}
.ios-spinner div.bar12 {
	-webkit-transform: rotate(330deg) translate(0, -130%);
	-webkit-animation-delay: -0.0833s;
}

.user-search-selected-tint {
	height: $profile-size;
	width: $profile-size;
	border-radius: 50%;
	border: solid 5px var(--teal-300);
	background: var(--teal-300);
}

.user-search-selected-tint {
	display: inline-block;
}

.user-search-selected-img {
	opacity: 0.7;
	display: block;
	filter: blur(0.5px);
	z-index: 1;
}

.filter-button {
	font-family: Avenir-Medium;
	font-size: 16px;
	color: var(--teal-300);
	padding: 10px 10px 10px 10px;
}

.filter-button-arrow {
	background-color: var(--neutral-0);
	width: 25px;
	position: absolute;
	top: 0;
	right: 0;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
	height: 38px;
	padding-top: 9px;
}
.filter-button-arrow img {
	margin-top: 8px;
}

.user-search-filter {
	height: 54px;
	border-radius: 10px;
	// background-color: var(--neutral-400);
	background-color: #edeef0;

	margin-top: 8px;
	padding-left: 16px;
	padding-right: 16px;
	position: relative;
}

.user-search-list-multi {
	height: calc(90vh - 308px);
}

.user-search-list-multi-modal {
	height: calc(80vh - 323px);
}

.upload-btn-wrapper-no-margin {
	margin-top: 0;
	margin-bottom: 20px;
}

.filter-span-text {
	width: 42px;
	height: 22px;
	font-family: Avenir-Roman;
	font-size: 16px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: normal;
	color: var(--neutral-800);
	margin-top: 16px;
}

.search-for-anyone-in {
	width: 246px;
	height: 19px;
	opacity: 0.5;
	font-family: Avenir-Roman;
	font-size: 14px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: normal;
	text-align: right;
	color: var(--neutral-800);
	position: absolute;
	top: 17px;
	right: 20px;
}

.filter-span-text,
.user-search-filter-dropdown,
.search-for-anyone-in {
	display: inline-block;
}

.dropdown-submenu {
	position: relative;
}

.dropdown-submenu > .dropdown-menu {
	top: 0;
	left: 100%;
	margin-top: -6px;
	margin-left: -1px;
	-webkit-border-radius: 0 6px 6px 6px;
	-moz-border-radius: 0 6px 6px;
	border-radius: 0 6px 6px 6px;
}

.dropdown-submenu:hover > .dropdown-menu {
	display: block;
}

.dropdown-submenu > a:after {
	display: block;
	content: ' ';
	float: right;
	width: 0;
	height: 0;
	border-color: transparent;
	border-style: solid;
	border-width: 5px 0 5px 5px;
	border-left-color: #ccc;
	margin-top: 5px;
	margin-right: -10px;
}

.dropdown-submenu:hover > a:after {
	border-left-color: #fff;
}

.dropdown-submenu.pull-left {
	float: none;
}

.dropdown-submenu.pull-left > .dropdown-menu {
	left: -100%;
	margin-left: 10px;
	-webkit-border-radius: 6px 0 6px 6px;
	-moz-border-radius: 6px 0 6px 6px;
	border-radius: 6px 0 6px 6px;
}

.filter-button {
	border: none;
	outline: 0;
	background-color: var(--neutral-0);
	border-radius: 10px;
	width: 320px;
	text-align: left;
	border-top-left-radius: 10px;
	border-bottom-left-radius: 10px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.main-menu,
.sub-menu {
	width: 320px;
	border-radius: 10px;
	background-color: var(--neutral-0);
	border: 1px solid var(--neutral-40040);
	-webkit-box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
	-moz-box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
	box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}

.sub-menu {
	position: absolute;
	width: 280px;
	left: 320px;
	top: 140px;
	overflow-y: auto;
	max-height: 50vh;
	overflow-x: hidden;
}

.main-item {
	padding: 10px 10px 10px 10px;
	cursor: pointer;
}

.sub-menu .group {
	cursor: pointer;
}

.category-name {
	font-family: Avenir-Heavy;
	font-size: 13px;
	letter-spacing: 1.63px;
	color: var(--neutral-800);
	background-color: #f7f7f7;
	padding-left: 24px;
	cursor: default;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	width: 278px;
	height: 26px;
	padding-top: 5px;
}

.group {
	padding: 20px 20px 20px 5px;
	width: 240px;
	margin: 0 auto;
	font-family: Avenir-Medium;
	font-size: 16px;
	line-height: 0.88;
	color: var(--neutral-800);
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	position: relative;
}

.group:hover {
	color: var(--teal-300);
}

.sub-item .group {
	border-bottom: 1px solid var(--neutral-200);
}

.sub-item .group:last-child {
	border: 0;
}

.main-item:hover {
	background-color: #f2f4f5;
}

.organization-item:hover .filter-button-arrow {
	background-color: #f2f4f5 !important;
}

.main-item:first-child:hover {
	border-radius: 10px 10px 0 0;
}

.main-item:last-child:hover {
	border-radius: 0 0 10px 10px;
}

.filter {
	display: block;
	z-index: 900;
	position: absolute;
	top: 6px;
	margin-left: 10px;
}

.selected-filter div {
	color: var(--teal-300) !important;
}

.main-item div {
	font-family: Avenir-Medium;
	font-size: 16px;
	margin: 0;
	padding: 0;
	color: var(--neutral-800);
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.main-item span {
	opacity: 0.5;
	font-family: Avenir-Medium;
	font-size: 14px;
	color: var(--neutral-800);
}

.user-search-list-opacity {
	opacity: 0.2;
	pointer-events: none;
}

.user-search-loading {
	text-align: center;
	height: calc(90vh - 203px);
	padding-top: calc(50vh - 308px);
}

.no-results-small {
	font-family: Avenir-Medium;
	color: rgb(138, 141, 147);
	font-size: 15px;
}

:disabled {
	background-color: #8a8d93;
}

:disabled:hover {
	background-color: #8a8d93;
	box-shadow: unset;
	cursor: default;
}

.disabled-div {
	pointer-events: none;
	color: #b7b9bd;
}

.disabled-div div,
.disabled-div span {
	pointer-events: none;
	color: #b7b9bd;
}

.group-item-is-selected {
	color: var(--teal-300);
}

.missing-img-white-bg {
	background-color: #ffffff;
}

.adjust-search-filter-link {
	font-family: Avenir-Heavy;
	color: var(--teal-300);
	text-decoration: none;
}
.user-search-item {
	padding: 12px;
	width: 100%;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.user-search-content-container {
	display: flex;
	align-items: center;
	flex: 1;
}
.user-profile-img-container {
	margin-right: 16px;
}
</style>

<style lang="scss">
@import 'src/sass/variables';
@include overrideScheme('dark') {
	.user-search-filter {
		background-color: var(--neutral-700);
	}
	.category-name {
		background-color: var(--neutral-300);
	}
	.main-item:hover {
		background-color: var(--neutral-300);
	}
	.organization-item:hover .filter-button-arrow {
		background-color: var(--neutral-300) !important;
	}
}
</style>
